import React from 'react';
import { PageHero } from '../components/Sections';
import { careersHtml as fb, siteSettings as fbSettings } from '../data/mock';
import { useContent } from '../context/ContentContext';
import HtmlWidget from '../components/HtmlWidget';
import Seo from '../components/Seo';
import { Mail, Phone } from 'lucide-react';

const Careers = () => {
  const { careersHtml = fb, siteSettings = fbSettings } = useContent();
  return (
    <div>
      <Seo
        title="HVAC Careers & Jobs in Cortez, CO | Comfort Air Mechanical"
        description="Join the Comfort Air Mechanical team in Cortez, CO. View current HVAC technician, installer and sheet metal job openings and apply online."
        path="/careers"
      />
      <PageHero title="Careers" subtitle="Join a hard-working local team that's been keeping Southwest Colorado comfortable since 1988." crumb="Careers" />
      <section className="section-pad bg-white">
        <div className="container-c grid grid-cols-1 lg:grid-cols-3 gap-10 items-start">
          <div className="lg:col-span-2">
            <HtmlWidget html={careersHtml} />
          </div>
          <aside className="lg:sticky lg:top-28">
            <div className="bg-brand-bluedeep rounded-2xl p-7 text-white">
              <h3 className="font-display font-bold text-xl mb-2">Ready to Apply?</h3>
              <p className="text-white/70 text-sm mb-5">Reach out and a member of our team will get back to you.</p>
              <a href={`mailto:${siteSettings.email}`} className="flex items-center gap-3 mb-3 hover:text-brand-green transition-colors">
                <Mail className="text-brand-green" size={20} /> <span className="font-medium">{siteSettings.email}</span>
              </a>
              <a href={`tel:${siteSettings.phoneRaw}`} className="flex items-center gap-3 hover:text-brand-green transition-colors">
                <Phone className="text-brand-green" size={20} /> <span className="font-display font-bold text-lg">{siteSettings.phone}</span>
              </a>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default Careers;
